import {
  FETCH_TANENTS_SUCCESS,
  TANENT_NAME,
  TANENT_EMAIL,
  TANENT_DESCRIPTION,
  TANENT_ACTION_SUCCESS,
  TANENT_STATUS_CHANGE_DIALOG_BOX,
  TANENT_CHANGE_STATUS_ID,
} from "../constants/tanent.constants";

const INIT_STATE = {
  tanents: [],
  new_tanent: {
    name: "",
    is_name_validation_error: false,
    email: "",
    is_email_validation_error: false,
    status: true,
    description: "",
  },
  dialog_box_status: false,
  change_status_id: null,
  change_id_status: null,
};

const tanentInfo = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_TANENTS_SUCCESS: {
      return {
        ...state,
        tanents: action.tanents.data,
      };
    }
    case TANENT_NAME: {
      return {
        ...state,
        new_tanent: {
          ...state.new_tanent,
          name: action.name,
          is_name_validation_error: !nameValidation(action.name),
        },
      };
    }
    case TANENT_EMAIL: {
      return {
        ...state,
        new_tanent: {
          ...state.new_tanent,
          email: action.email,
          is_email_validation_error: !emailValidation(action.email),
        },
      };
    }
    case TANENT_DESCRIPTION: {
      return {
        ...state,
        new_tanent: {
          ...state.new_tanent,
          description: action.description,
        },
      };
    }
    case TANENT_ACTION_SUCCESS: {
      return {
        ...state,
        tanents: action.tanents.data,
        new_tanent: INIT_STATE.new_tanent,
        change_status_id: null,
        change_id_status: null,
      };
    }
    case TANENT_STATUS_CHANGE_DIALOG_BOX: {
      return {
        ...state,
        dialog_box_status: action.status,
      };
    }
    case TANENT_CHANGE_STATUS_ID: {
      return {
        ...state,
        change_status_id: action.id,
        change_id_status: action.status,
      };
    }
    default:
      return state;
  }
};

export default tanentInfo;

const nameValidation = (name_value) => {
  const pattern_expression = new RegExp("^[a-z_]*$");
  return pattern_expression.test(name_value);
};

const emailValidation = (email_value) => {
  var validator = require("validator");
  return validator.isEmail(email_value);
};
